<template src="./templates/Results.html" />

<script setup>

import {
    buildListingLink,
    useResultsStore,
    useQueryParamsStore,
    useMap,
    useRegionsStore,
    useLocationsStore,
    useMapStore,
} from '@timezoneone/dottie-client-jam';

import { FavouriteIcon } from '@timezoneone/favourites';

import { ref } from 'vue';
import ResultsHeader from './ResultsHeader.vue';
import { config } from '../config/config';

const queryParams = useQueryParamsStore();
const regionsStore = useRegionsStore();
const locationsStore = useLocationsStore();
const resultsStore = useResultsStore();
const mapStore = useMapStore();

const { toggleMap } = useMap(
    config,
    regionsStore,
    locationsStore,
    resultsStore,
    queryParams,
    mapStore,
);

const customSort = ref(queryParams.params.customSort || '');

const favButtonCssClasses = ['button', 'favourites', 'small'];

</script>
